import { render, staticRenderFns } from "./AccountFeed.vue?vue&type=template&id=31eb3135&scoped=true&"
import script from "./AccountFeed.vue?vue&type=script&lang=ts&"
export * from "./AccountFeed.vue?vue&type=script&lang=ts&"
import style0 from "./AccountFeed.vue?vue&type=style&index=0&id=31eb3135&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb3135",
  null
  
)

export default component.exports